import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { GOOGLE_REVIEWS_URL } from "../data/content";

const reveal = {
  hidden: { opacity: 0, y: 30 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] },
  }),
};

export const Voices = ({ title, voices, reviewsCta }) => {
  return (
    <section
      id="voices"
      data-testid="voices-section"
      className="mx-auto max-w-[1400px] px-6 md:px-10 py-20 md:py-28 border-t border-[#E6E3DC]"
    >
      <motion.div
        variants={reveal}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-80px" }}
        className="flex items-center gap-4 mb-4"
      >
        <span className="h-px w-10 bg-[#B0863A]" />
        <span className="overline text-[#7A8091]">{title}</span>
      </motion.div>

      <div className="mt-6">
        {voices.map((v, i) => (
          <motion.blockquote
            key={i}
            custom={i}
            variants={reveal}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-60px" }}
            data-testid="voice-quote"
            className="group border-t border-[#E6E3DC] py-8 md:py-12 font-serif-display italic font-light text-[#171B26] text-2xl md:text-4xl lg:text-5xl leading-[1.15] tracking-tight"
          >
            <span className="text-[#B0863A] mr-1 transition-transform duration-500 inline-block group-hover:-translate-y-1">“</span>
            {v}
          </motion.blockquote>
        ))}
      </div>

      <motion.div
        variants={reveal}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-60px" }}
        className="mt-12 md:mt-16 flex justify-start"
      >
        <a
          href={GOOGLE_REVIEWS_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="google-reviews-link"
          className="group inline-flex items-center gap-3 border border-[#E6E3DC] hover:border-[#B0863A] rounded-full pl-5 pr-6 py-3 transition-colors duration-400"
        >
          <span className="flex items-center gap-0.5 text-[#B0863A]">
            {[0, 1, 2, 3, 4].map((i) => (
              <Star key={i} size={15} strokeWidth={0} fill="currentColor" />
            ))}
          </span>
          <span className="text-[#171B26] text-sm font-medium group-hover:text-[#B0863A] transition-colors duration-400">
            {reviewsCta}
          </span>
        </a>
      </motion.div>
    </section>
  );
};
